// @flow
import styleConfig from './styleConfig'
import { pxToRem } from './util'

export const largeTitle = {
  fontSize: pxToRem(42),
  lineHeight: 56 / 42,
  fontWeight: 300,
  letterSpacing: '-0.02em',
}

export const title1 = {
  fontSize: pxToRem(36),
  lineHeight: 42 / 24,
  fontWeight: 300,
  letterSpacing: '-0.01em',
}

export const title2 = {
  fontSize: pxToRem(24),
  lineHeight: 34 / 20,
  fontWeight: 300,
  letterSpacing: '-0.01em',
}

export const title3 = {
  fontSize: pxToRem(20),
  lineHeight: 29 / 17,
  fontWeight: 300,
  letterSpacing: '-0.01em',
}

export const headline = {
  fontSize: pxToRem(18),
  lineHeight: 27 / 18,
  fontWeight: 700,
}

export const body = {
  fontSize: pxToRem(18),
  lineHeight: 27 / 18,
  fontWeight: 300,
}

export const nav = {
  fontSize: pxToRem(14),
  lineHeight: 20 / 14,
  fontWeight: 300,
}

export const meta = {
  fontSize: pxToRem(12),
  lineHeight: 16 / 12,
  fontWeight: 300,
  letterSpacing: '0.01em',
}

export const micro = {
  fontSize: pxToRem(10),
  lineHeight: 14 / 10,
  fontWeight: 900,
  letterSpacing: '0.02em',
  textTransform: 'uppercase',
}

export const monospace = {
  fontFamily: styleConfig.fonts.monoSpaceFontFamily,
}

export const antialiased = {
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
}



// WEBPACK FOOTER //
// ./src/style/typography.js